import { json, CustomerAPI, RxCustomerAPI, checkStatus } from '@driftt/dapper'

export const api = {
  rxFetch() {
    return RxCustomerAPI.get('/rules/all')
      .checkStatus()
      .retryWithBackoff()
  },

  fetchRules() {
    return CustomerAPI.get('/rules/all').then(json)
  },

  fetchRulesByIds(ruleIds) {
    return RxCustomerAPI.post('/rules/by_id', ruleIds).checkStatus()
  },

  fetchRoundRobin(roundRobinKey) {
    return RxCustomerAPI.get(`/organizations/round-robin/${roundRobinKey}`)
      .checkStatus()
  },

  createRule(data) {
    return CustomerAPI.post('/rules', data)
  },

  editRule(data, id) {
    return CustomerAPI.patch(`/rules/${id}`, data)
  },

  editOncall(data) {
    return CustomerAPI.patch(`/rules/on_call`, data).then(checkStatus)
  },

  fetchRule(id) {
    return CustomerAPI.get(`/rules/${id}`).then(json)
  },

  deleteRule(id) {
    return CustomerAPI.patch(`/rules/${id}`, { status: 'ARCHIVED' })
  },

  undoDeleteRule(id) {
    return CustomerAPI.patch(`/rules/${id}`, { status: 'ENABLED' })
  },

  updatePriority(priority, id) {
    return CustomerAPI.patch(`/rules/${id}/reorder?to=${priority}`).then(json)
  },

  optInCentralRouting() {
    return CustomerAPI.post('/organizations/centralized_routing?enabled=true').then(json)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/api.js